// dependency-graph-ignore-file
import {
  type Database,
  getOrderWithFallback,
  placeIdsInOrder
} from '@databases/model/database';

export function reorderEntries(
  ydb: Database,
  { entryIds, newIndex }: { entryIds: string[]; newIndex: number }
): void {
  ydb.mutate((db) => {
    const globalOrder = placeIdsInOrder(db.entries, entryIds, newIndex);
    const afterMovedEntriesIndex = globalOrder.indexOf(entryIds[0]) + entryIds.length;
    const beforeEntryId = globalOrder[afterMovedEntriesIndex];
    const globalIndex = beforeEntryId
      ? db.entries.indexOf(beforeEntryId)
      : db.entries.length;
    db.reorderEntries(entryIds, globalIndex);

    Object.entries(db.viewOrders).forEach(([viewId, viewOrder]) => {
      const order = getOrderWithFallback(db.entries, viewOrder.entryOrder);
      db.setViewEntryOrder(
        viewId,
        placeIdsInOrder(order, entryIds, newIndex),
        'preserve-ordering-mode'
      );
    });
  });
}
